import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

export default function Nav({ registrationCount }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "Proyecto", href: "#about" },
    { label: "Fundadora", href: "#founder" },
    { label: "Cómo Funciona", href: "#how" },
    { label: "Impacto", href: "#stats" },
  ];

  return (
    <nav
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-slate-950/80 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex items-center justify-between h-20">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
          aria-label="Sin aletas no hay paraíso"
        >
          <img
            src="/logo.png"
            alt="Sin aletas no hay paraíso"
            className="h-11 sm:h-12 w-auto transition-transform duration-500 group-hover:scale-105"
          />
        </a>

        <div className="hidden md:flex items-center gap-9">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.href.replace("#", "")}`}
              className="text-sm text-slate-300 hover:text-cyan-400 transition-colors"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href="#register"
            data-testid="nav-cta"
            className="hidden md:inline-flex bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-bold text-sm px-5 py-2.5 rounded-full transition-all duration-300 hover:-translate-y-0.5 shadow-[0_0_20px_rgba(34,211,238,0.25)] hover:shadow-[0_0_30px_rgba(34,211,238,0.5)]"
          >
            Únete
          </a>
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            data-testid="mobile-menu-toggle"
            className="md:hidden text-white p-2"
            aria-label="Menu"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-slate-950/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-5"
        >
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              className="text-slate-300 hover:text-cyan-400 transition-colors text-base"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#register"
            onClick={() => setMobileOpen(false)}
            className="bg-cyan-500 text-slate-950 font-bold text-center px-5 py-3 rounded-full"
          >
            Únete a la campaña
          </a>
        </div>
      )}
    </nav>
  );
}
